import type { User } from "~/common/interfaces/entities/user.interface";

export const getUserDefault = (): User => ({
	id: 0,
	email: "",
	isActive: false,
	roles: [],
	createdAt: new Date().toLocaleString(),
	updatedAt: new Date().toLocaleString()
});
